<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10 page-container">
          <b-row v-if="id" id="g-is_active" class="mb-5" align-v="end">
            <b-col class="col-end">
              <div style="display: block">
                <b-form-checkbox switch size="lg" :disabled="!disable_form &&
                  (form.liff_id_before_loading === '' ||
                    form.liff_id_before_loading === null)
                  " v-model="form.is_active" @change="toggleIsActive" name="is_active">
                  <span v-html="form.is_active
                      ? '<span style=color:green>เปิดการใช้งาน</span>'
                      : '<span style=color:red;>ปิดการใช้งาน</span>'
                    ">
                  </span>
                </b-form-checkbox>

                <b-form-text id="input-live-help" v-if="
                  form.liff_id_before_loading === '' ||
                  form.liff_id_before_loading === null
                ">
                  {{ $t("PAGE.CAMPAIGN.FORM.HINT.IS_ACTIVE") }}
                </b-form-text>
              </div>
            </b-col>
          </b-row>
          <b-form @submit.stop.prevent="onSubmit()">
            <div>
              <!-- Tabs with card integration; header scrolls horizontally when many tabs -->
              <div class="campaign-form-tabs-wrap">
                <b-card no-body>
                  <b-tabs v-model="campaign_active_tab_index" card>
                    <b-tab id="t-general" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.GENERAL'
                    )
                      ">
                      <b-card-text>
                        <b-row v-if="id" id="g-liff_id" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>LINE LIFF ID</h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-input id="liff-id-input" name="liff-id-input" v-model="form.liff_id"
                              :disabled="disable_form"></b-form-input>
                          </b-col>
                        </b-row>

                        <b-row v-if="id" id="g-campaign_url" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  this.$t(
                                    "PAGE.CAMPAIGN.TABLE.FIELDS.CAMPAIGN_URL"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-input-group class="mb-2">
                              <b-form-input id="campaign-url-input" name="campaign-url-input" v-model="liff_client_url"
                                readonly></b-form-input>
                              <b-input-group-append>
                                <b-button @click="copyText('campaign-url-input')" variant="primary">Copy</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                        </b-row>
                        <b-row id="g-name" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.TYPEREWORD") }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-select v-model="$v.form.is_redeem_reward.$model" :disabled="disable_form"
                              :options="optionsType">
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row id="g-name" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.DEFAULT.FORM.FIELDS.MODE_OF_CAMPAIGN"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-select v-model="$v.form.is_mode_login.$model" :disabled="disable_form"
                              :options="optionsModeOfCampaign">
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row id="g-name" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>{{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}</h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-input id="name-input" name="name-input" v-model="$v.form.name.$model"
                              :state="validateState('name')" aria-describedby="name-live-feedback"
                              :disabled="disable_form"></b-form-input>

                            <b-form-invalid-feedback id="name-live-feedback">
                              <span v-if="!$v.form.name.required" class="error">
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                              <span v-if="!$v.form.name.maxLength" class="error">
                                {{
                                  $t(
                                    "PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH",
                                    {
                                      max: 256
                                    }
                                  )
                                }}
                              </span>
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>

                        <b-row v-if="showCampaignDetailField" id="g-detail" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.DETAIL") }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <ckeditor :editor="editor" v-model="$v.form.detail.$model" :state="validateState('detail')"
                              aria-describedby="name-live-feedback" :disabled="disable_form" :config="editorConfig">
                            </ckeditor>

                            <b-form-invalid-feedback id="name-live-feedback">
                              <span v-if="!$v.form.detail.required" class="error">
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>

                        <b-row id="g-start_date" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.START_DATE") }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <date-picker id="start-date-datepicker" v-model="$v.form.start_date.$model"
                              :disabled="disable_date_form" :config="options" autocomplete="off"></date-picker>
                            <span v-if="isSubmit && !$v.form.start_date.required" class="error text-danger">
                              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                            </span>
                          </b-col>
                        </b-row>

                        <b-row id="g-end_date" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.END_DATE") }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <date-picker id="end-date-datepicker" v-model="$v.form.end_date.$model"
                              :disabled="disable_date_form" :config="options" autocomplete="off"></date-picker>
                            <span v-if="isSubmit && !$v.form.end_date.required" class="error text-danger">
                              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                            </span>
                          </b-col>
                        </b-row>

                        <b-row id="g-line_message_token" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.LINE_MESSAGE_TOKEN"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-textarea id="line_message_token-input" name="line_message_token-input"
                              v-model="form.line_message_token" aria-describedby="name-live-feedback" rows="3"
                              max-rows="6"></b-form-textarea>
                          </b-col>
                        </b-row>

                        <b-row v-if="showCampaignMainImageField" id="g-main-image" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.MAIN_IMAGE") }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-file v-model="form.image_file" @change="handleMainImage" accept="image/*"
                              :placeholder="this.$t(
                                'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                              )
                                " drop-placeholder="Drop file here..." :disabled="disable_form"></b-form-file>
                            <div v-if="preview.image" class="mt-2">
                              <div class="row">
                                <div class="col-3">
                                  <img :src="preview.image" alt="Main image" class="image-preview" />
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row id="g-other-image" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t("PAGE.DEFAULT.FORM.FIELDS.BANNER_IMAGE")
                                }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-file v-model="form.image_file" @change="handleBannerImage" accept="image/*"
                              :placeholder="this.$t(
                                'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                              )
                                " drop-placeholder="Drop file here..." :disabled="disable_form"></b-form-file>
                            <b-form-text id="input-live-help">
                              {{ $t("PAGE.CAMPAIGN.FORM.HINT.BANNER_SCALE") }}
                            </b-form-text>
                          </b-col>
                          <b-col sm="2"></b-col>
                          <b-col sm="10">
                            <div v-if="preview.images" class="row">
                              <div v-for="(item, index) in preview.images" :key="index" class="col-6 my-2">
                                <img width="414" height="165" :src="item.image" alt="Banner image"
                                  class="image-preview image-object-fit" />
                                <div class="col-md-12 text-center">
                                  <button type="button" :disabled="disable_form" @click="deleteBannerImage(index)"
                                    class="btn btn-danger">
                                    ลบ
                                  </button>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>

                        <CampaignLanding :form="form" :isSubmit="isSubmit" />

                        <b-row v-if="showReceiptVerifyRegexField" id="g-receipt_verify_regex" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_VERIFY_REGEX"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-input id="receipt-verify-regex-input" v-model="form.receipt_verify_regex"
                              :disabled="disable_form" :placeholder="$t(
                                'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_VERIFY_REGEX_PLACEHOLDER'
                              )
                                "></b-form-input>
                            <b-form-text id="receipt-verify-regex-hint">
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_VERIFY_REGEX_HINT"
                                )
                              }}
                            </b-form-text>
                          </b-col>
                        </b-row>

                        <b-row id="g-point-accumulation" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>เปิดใช้การสะสมแต้ม</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-checkbox switch size="lg" v-model="form.is_receipt_upload_enabled"
                              :disabled="disable_form" name="is_receipt_upload_enabled">
                              <span v-if="form.is_receipt_upload_enabled" style="color: green">เปิด</span>
                              <span v-else style="color: #6c757d">ปิด</span>
                            </b-form-checkbox>
                          </b-col>
                        </b-row>

                        <b-row id="g-qr-redeem" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>เปิดใช้สแกนแลกแต้ม</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-checkbox switch size="lg" v-model="form.is_qr_scan_enabled"
                              :disabled="disable_form" name="is_qr_scan_enabled">
                              <span v-if="form.is_qr_scan_enabled" style="color: green">เปิด</span>
                              <span v-else style="color: #6c757d">ปิด</span>
                            </b-form-checkbox>
                          </b-col>
                        </b-row>

                        <b-row id="g-staff-qr-scan" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>เปิดใช้สแกน QR ให้แต้ม</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-checkbox switch size="lg" v-model="form.is_staff_qr_scan_enabled"
                              :disabled="disable_form" name="is_staff_qr_scan_enabled">
                              <span v-if="form.is_staff_qr_scan_enabled" style="color: green">เปิด</span>
                              <span v-else style="color: #6c757d">ปิด</span>
                            </b-form-checkbox>
                          </b-col>
                        </b-row>

                        <b-row v-if="showValueBasedPointsSection" id="g-value-based-points" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.ENABLE_VALUE_BASED_POINTS"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-checkbox switch size="lg" v-model="form.is_enable_value_based_points"
                              :disabled="disable_form" name="is_enable_value_based_points"
                              @change="onValueBasedPointsToggle">
                              <span v-if="form.is_enable_value_based_points" style="color: green">{{
                                $t("PAGE.DEFAULT.FORM.OPTIONS.ON") }}</span>
                              <span v-else style="color: #6c757d">{{
                                $t("PAGE.DEFAULT.FORM.OPTIONS.OFF")
                                }}</span>
                            </b-form-checkbox>
                            <b-row class="mt-3">
                              <b-col sm="12" md="6" class="mb-3 mb-md-0">
                                <label class="d-block mb-1">
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.VALUE_BASED_AMOUNT"
                                    )
                                  }}
                                </label>
                                <b-form-input id="value-based-amount-input" type="number" step="0.01" min="0" :disabled="!form.is_enable_value_based_points ||
                                  disable_form
                                  " v-model="$v.form.value_based_amount.$model"
                                  :state="validateState('value_based_amount')"
                                  aria-describedby="value-based-amount-feedback"
                                  @wheel="$event.target.blur()"></b-form-input>
                                <b-form-invalid-feedback id="value-based-amount-feedback">
                                  <span v-if="!$v.form.value_based_amount.required" class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.REQUIRED"
                                      )
                                    }}
                                  </span>
                                  <span v-else-if="
                                    !$v.form.value_based_amount.minAmount
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.MIN_VALUE",
                                        {
                                          min: 0.01
                                        }
                                      )
                                    }}
                                  </span>
                                </b-form-invalid-feedback>
                              </b-col>
                              <b-col sm="12" md="6">
                                <label class="d-block mb-1">
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.VALUE_BASED_POINTS"
                                    )
                                  }}
                                </label>
                                <b-form-input id="value-based-points-input" type="number" min="1" step="1" :disabled="!form.is_enable_value_based_points ||
                                  disable_form
                                  " v-model="$v.form.value_based_points.$model"
                                  :state="validateState('value_based_points')"
                                  aria-describedby="value-based-points-feedback" @wheel="$event.target.blur()"
                                  @keypress="isNumber($event)"></b-form-input>
                                <b-form-invalid-feedback id="value-based-points-feedback">
                                  <span v-if="!$v.form.value_based_points.required" class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.REQUIRED"
                                      )
                                    }}
                                  </span>
                                  <span v-else-if="
                                    !$v.form.value_based_points.minPoints
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.MIN_VALUE",
                                        {
                                          min: 1
                                        }
                                      )
                                    }}
                                  </span>
                                </b-form-invalid-feedback>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>

                        <b-row id="g-referral" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.ENABLE_REFERRAL"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-checkbox switch size="lg" v-model="form.is_referral_enabled"
                              :disabled="disable_form" name="is_referral_enabled">
                              <span v-if="form.is_referral_enabled" style="color: green">{{
                                $t("PAGE.DEFAULT.FORM.OPTIONS.ON") }}</span>
                              <span v-else style="color: #6c757d">{{
                                $t("PAGE.DEFAULT.FORM.OPTIONS.OFF")
                                }}</span>
                            </b-form-checkbox>
                            <b-form-text id="referral-hint">
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REFERRAL_HINT"
                                )
                              }}
                            </b-form-text>
                            <b-row class="mt-3">
                              <b-col sm="12" md="6" class="mb-3 mb-md-0">
                                <label class="d-block mb-1">
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REFERRAL_INVITER_POINT"
                                    )
                                  }}
                                </label>
                                <b-form-input id="referral-inviter-point-input" type="number" min="0" step="1"
                                  :disabled="!form.is_referral_enabled || disable_form"
                                  v-model="form.referral_inviter_point" @wheel="$event.target.blur()"
                                  @keypress="isNumber($event)"></b-form-input>
                              </b-col>
                              <b-col sm="12" md="6">
                                <label class="d-block mb-1">
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REFERRAL_INVITEE_POINT"
                                    )
                                  }}
                                </label>
                                <b-form-input id="referral-invitee-point-input" type="number" min="0" step="1"
                                  :disabled="!form.is_referral_enabled || disable_form"
                                  v-model="form.referral_invitee_point" @wheel="$event.target.blur()"
                                  @keypress="isNumber($event)"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>

                        <b-row v-if="showValueBasedPointsSection && !isTransferSlipCompany" id="g-ocr-item-filter-prompt" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>กรองรายการสำหรับคิดแต้ม (AI)</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-textarea
                              id="ocr-item-filter-prompt-input"
                              v-model="form.ocr_item_filter_prompt"
                              :disabled="(disable_form && !isSuperAdmin) || ocrFilterPromptRefining"
                              placeholder="เช่น: คิดแต้มเฉพาะค่าอาหาร ไม่รวมน้ำดื่ม เครื่องดื่ม น้ำแข็ง เหล้า เบียร์"
                              rows="3"
                            ></b-form-textarea>
                            <div class="d-flex align-items-center mt-2" style="gap:8px">
                              <b-form-text class="mb-0">
                                กำหนด rule ให้ AI แยกแยะรายการที่จะนำมาคิดแต้ม หากเว้นว่างไว้จะใช้ยอดรวมทั้งใบเสร็จ
                              </b-form-text>
                              <b-button
                                v-if="canShowAiRefinePromptButtons"
                                size="sm"
                                variant="outline-primary"
                                :disabled="!ocrItemFilterPromptHasText || ocrFilterPromptRefining"
                                @click="refineOcrFilterPromptWithAi"
                                style="white-space:nowrap;flex-shrink:0"
                              >
                                <span v-if="ocrFilterPromptRefining">
                                  <b-spinner small></b-spinner> กำลังปรับ...
                                </span>
                                <span v-else>✨ ปรับด้วย AI</span>
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row v-if="showReceiptDuplicatePromptField && !isTransferSlipCompany" id="g-receipt-duplicate-prompt" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>เกณฑ์อ่านเลขใบเสร็จ (AI)</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-textarea
                              id="receipt-duplicate-prompt-input"
                              v-model="form.receipt_duplicate_prompt"
                              :disabled="(disable_form && !isSuperAdmin) || receiptDuplicatePromptRefining"
                              placeholder="เช่น: ใช้เบอร์โทรลูกค้า + วันที่ + เวลา (ระดับนาที) รวมกันเป็นเลขใบเสร็จ"
                              rows="3"
                            ></b-form-textarea>
                            <div class="d-flex align-items-center mt-2" style="gap:8px">
                              <b-form-text class="mb-0">
                                เมื่อกรอกเกณฑ์นี้ AI จะใช้เกณฑ์ที่กรอกในการสร้างเลขใบเสร็จเสมอ โดยไม่ใช้เลขที่ใบเสร็จที่พิมพ์อยู่บนใบเลย (ถ้าอ่านค่าตามเกณฑ์ไม่ครบ ใบเสร็จนั้นจะรอตรวจเอง แทนที่จะย้อนกลับไปใช้เลขที่พิมพ์บนใบ) — เว้นว่าง = ให้ AI อ่านเลขที่ใบเสร็จที่พิมพ์บนใบตามปกติ
                              </b-form-text>
                              <b-button
                                v-if="canShowAiRefinePromptButtons"
                                size="sm"
                                variant="outline-primary"
                                :disabled="!receiptDuplicatePromptHasText || receiptDuplicatePromptRefining"
                                @click="refineReceiptDuplicatePromptWithAi"
                                style="white-space:nowrap;flex-shrink:0"
                              >
                                <span v-if="receiptDuplicatePromptRefining">
                                  <b-spinner small></b-spinner> กำลังปรับ...
                                </span>
                                <span v-else>✨ ปรับด้วย AI</span>
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row v-if="showApprovalCriteriaPromptField" id="g-approval-criteria-prompt" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>เกณฑ์การอนุมัติ (AI)</h5>
                            </label>
                          </b-col>
                          <b-col sm="10">
                            <b-form-textarea
                              id="approval-criteria-prompt-input"
                              v-model="form.approval_criteria_prompt"
                              :disabled="(disable_form && !isSuperAdmin) || approvalCriteriaPromptRefining"
                              placeholder="เช่น: อนุมัติเฉพาะใบเสร็จที่วันที่ใบเสร็จอยู่ในช่วงแคมเปญ และเป็นวันเดียวกับวันที่อัพโหลด"
                              rows="3"
                            ></b-form-textarea>
                            <div class="d-flex align-items-center mt-2" style="gap:8px">
                              <b-form-text class="mb-0">
                                ใช้ตัดสินว่าจะอนุมัติใบเสร็จอัตโนมัติหรือไม่ (เป็นเงื่อนไขเพิ่มจากการตรวจเลขใบเสร็จเดิม — ใบเสร็จต้องผ่านทั้งสองอย่างจึงอนุมัติอัตโนมัติ) เว้นว่าง = ไม่ใช้เกณฑ์นี้ ใบที่ไม่ผ่านจะตกไปรอตรวจเอง
                              </b-form-text>
                              <b-button
                                v-if="canShowAiRefinePromptButtons"
                                size="sm"
                                variant="outline-primary"
                                :disabled="!approvalCriteriaPromptHasText || approvalCriteriaPromptRefining"
                                @click="refineApprovalCriteriaPromptWithAi"
                                style="white-space:nowrap;flex-shrink:0"
                              >
                                <span v-if="approvalCriteriaPromptRefining">
                                  <b-spinner small></b-spinner> กำลังปรับ...
                                </span>
                                <span v-else>✨ ปรับด้วย AI</span>
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row id="g-term_and_condition" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.TERM_AND_CONDITION"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <ckeditor :editor="editor" v-model="$v.form.term_and_condition.$model"
                              :state="validateState('term_and_condition')" aria-describedby="name-live-feedback"
                              :disabled="disable_form" :config="editorConfig"></ckeditor>
                          </b-col>
                        </b-row>

                        <CampaignPolicy :form="form" :isSubmit="isSubmit" />
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="showReceiptTypeTab" id="t-receipt" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.RECEIPT'
                    )
                      ">
                      <b-card-text>
                        <b-row id="rc-receipt-selection" class="mb-5">
                          <b-col sm="2">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_TYPE"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="10">
                            <b-form-radio-group v-model="receipt_selection" :options="receipt_selection_option"
                              class="mb-3" value-field="item" text-field="name" @change="onReceiptSelectionChanged"
                              :disabled="disable_form"></b-form-radio-group>
                            <div class="d-flex flex-wrap align-items-center justify-content-between">
                              <p class="text-muted mb-0">
                                เลือกแล้ว {{ selectedReceiptTypeCount }} /
                                {{ receipt_list.length }} ประเภท
                              </p>
                              <b-button v-if="receipt_selection === 'custom'" variant="link"
                                class="p-0 text-nowrap rc-receipt-deselect-all" :disabled="disable_form"
                                @click.prevent="clearAllReceiptTypes">
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.DESELECT_ALL_RECEIPT_TYPES"
                                  )
                                }}
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row id="rc-receipt-selection" class="mb-5">
                          <b-col sm="12">
                            <p v-if="!disable_form" class="ps-note">
                              * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                            </p>

                            <b-form-checkbox-group size="lg" id="receipt-type-input" name="receipt-type"
                              v-model="$v.form.receipt_type.$model" :state="validateState('receipt_type')"
                              :options="receipt_list" aria-describedby="name-live-feedback" stacked :disabled="receipt_selection == 'all' || disable_form
                                "></b-form-checkbox-group>
                          </b-col>
                        </b-row>
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="showProductTab" id="t-product" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.PRODUCT'
                    )
                      ">
                      <b-card-text>
                        <div class="text-right mb-5">
                          <b-button @click.prevent="openProductModal()" variant="primary">{{
                            $t("PAGE.DEFAULT.FORM.BTN_ADD") }}</b-button>
                        </div>

                        <b-modal id="modal-product-form" ref="modal" :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.PRODUCT_TITLE')
                          " :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')" :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')
                            " @hidden="resetProductModal" @ok="handleSubmitProduct">
                          <form ref="form" @submit.stop.prevent="handleSaveProduct">
                            <b-row id="mrcp-product-name" class="mb-5">
                              <b-col sm="2">
                                <label>
                                  <h5>
                                    {{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}
                                  </h5>
                                </label>
                              </b-col>

                              <b-col sm="10">
                                <b-form-input id="rcp-product-name-input" name="rcp-product-name-input" v-model="$v.form_receipt_product.product_name.$model
                                  " :state="validateProductModalState('product_name')
                                    " aria-describedby="name-live-feedback"></b-form-input>

                                <b-form-invalid-feedback id="name-live-feedback">
                                  <span v-if="
                                    !$v.form_receipt_product.product_name
                                      .required
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.REQUIRED"
                                      )
                                    }}
                                  </span>
                                  <span v-if="
                                    !$v.form_receipt_product.product_name
                                      .maxLength
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH",
                                        {
                                          max: 256
                                        }
                                      )
                                    }}
                                  </span>
                                </b-form-invalid-feedback>
                              </b-col>
                            </b-row>

                            <b-row id="mrcp-quantity" class="mb-5">
                              <b-col sm="2">
                                <label>
                                  <h5>
                                    {{
                                      $t("PAGE.DEFAULT.FORM.FIELDS.QUANTITY")
                                    }}
                                  </h5>
                                </label>
                              </b-col>

                              <b-col sm="10">
                                <b-form-input type="number" min="1" id="rcp-quantity-input" name="rcp-quantity-input"
                                  @wheel="$event.target.blur()" @keypress="isNumber($event)" v-model="$v.form_receipt_product.quantity.$model
                                    " :state="validateProductModalState('quantity')"
                                  aria-describedby="name-live-feedback"></b-form-input>

                                <b-form-invalid-feedback id="name-live-feedback">
                                  <span v-if="
                                    !$v.form_receipt_product.quantity.required
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.REQUIRED"
                                      )
                                    }}
                                  </span>
                                </b-form-invalid-feedback>
                              </b-col>
                            </b-row>

                            <b-row id="mrcp-point" class="mb-5">
                              <b-col sm="2">
                                <label>
                                  <h5>
                                    {{ $t("PAGE.DEFAULT.FORM.FIELDS.POINT") }}
                                  </h5>
                                </label>
                              </b-col>

                              <b-col sm="10">
                                <b-form-input type="number" @wheel="$event.target.blur()" @keypress="isNumber($event)"
                                  id="rcp-point-input" name="rcp-point-input"
                                  v-model="$v.form_receipt_product.point.$model"
                                  :state="validateProductModalState('point')"
                                  aria-describedby="name-live-feedback"></b-form-input>

                                <b-form-invalid-feedback id="name-live-feedback">
                                  <span v-if="
                                    !$v.form_receipt_product.point.required
                                  " class="error">
                                    {{
                                      $t(
                                        "PAGE.DEFAULT.FORM.VALIDATION.REQUIRED"
                                      )
                                    }}
                                  </span>
                                </b-form-invalid-feedback>
                              </b-col>
                            </b-row>
                          </form>
                        </b-modal>

                        <p v-if="
                          !disable_form && form.receipt_product.length == 0
                        " class="ps-note">
                          * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                        </p>

                        <div class="table-responsive">
                          <b-table id="organizations-table" :striped="false" :items="form.receipt_product"
                            :fields="table_receipt_product.fields" :borderless="false" head-variant="light">
                            <template #cell(action)="data">
                              <a href="javascript:" @click.prevent="
                                openProductModal(data.item, data.index)
                                " class="btn btn-icon btn-light btn-sm" :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')
                                  ">
                                <span class="svg-icon svg-icon-md svg-icon-success">
                                  <inline-svg src=" media/svg/icons/General/Edit.svg"></inline-svg>
                                </span> </a>&nbsp;&nbsp;&nbsp;
                              <a href="javascript:" @click.prevent="
                                removeReceiptProduct(data.index)
                                " class="btn btn-icon btn-light btn-sm" :aria-label="$t(
                                  'PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE'
                                )
                                  ">
                                <span class="svg-icon svg-icon-md svg-icon-danger">
                                  <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                                </span>
                              </a>
                            </template>
                          </b-table>

                          <p class="text-center pt-3" v-if="form.receipt_product.length < 1">
                            {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                          </p>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <b-tab id="t-reward" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.REWARD'
                    )
                      ">
                      <b-card-text>
                        <div class="text-right mb-5">
                          <b-button @click.prevent="openRewardModal()" variant="primary">{{
                            $t("PAGE.DEFAULT.FORM.BTN_ADD") }}</b-button>
                        </div>
                      </b-card-text>

                      <b-modal id="modal-reward-form" ref="modal" :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.REWARD_TITLE')
                        " :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
                        :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')" @hidden="resetRewardModal"
                        @ok="handleSubmitReward" size="lg">
                        <form ref="form" @submit.stop.prevent="handleSaveReward">
                          <b-row id="mrw-reward-name" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>
                                  {{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="9">
                              <b-form-input id="rw-product-name-input" name="rw-product-name-input" v-model="$v.form_receipt_reward.reward_name.$model
                                " :state="validateRewardModalState('reward_name')"
                                aria-describedby="name-live-feedback"></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span v-if="
                                  !$v.form_receipt_reward.reward_name.required
                                " class="error">
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                                <span v-if="
                                  !$v.form_receipt_reward.reward_name
                                    .maxLength
                                " class="error">
                                  {{
                                    $t(
                                      "PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH",
                                      {
                                        max: 256
                                      }
                                    )
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>

                          <b-row id="mrw-reward-name" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.IMAGE"
                                    )
                                  }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="9">
                              <b-form-file ref="file-input" @change="handleReceiptRewardImage($event)"
                                :state="validateRewardModalState('newImage')" aria-describedby="newImage-live-feedback"
                                accept="image/*" :placeholder="this.$t(
                                  'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                                )
                                  " drop-placeholder="Drop file here..."></b-form-file>
                              <b-form-invalid-feedback id="newImage-live-feedback">
                                <span v-if="
                                  !$v.form_receipt_reward.newImage.required
                                " class="error">
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                              </b-form-invalid-feedback>

                              <div v-if="form_receipt_reward.newImage" class="my-2">
                                <div class="row">
                                  <div class="col-3">
                                    <img :src="form_receipt_reward.newImage" alt="Main image" class="image-preview" />
                                  </div>
                                </div>
                              </div>

                              <div v-if="
                                !form_receipt_reward.newImage &&
                                form_receipt_reward.image
                              " class="my-2">
                                <div class="row">
                                  <div class="col-3">
                                    <img :src="`${ADMIN_IMAGE_URL}/${form_receipt_reward.image}`" alt="Main image"
                                      class="image-preview" />
                                  </div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>

                          <b-row id="mrw-reward-quantity" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.QUANTITY"
                                    )
                                  }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="9">
                              <b-form-input id="rw-product-name-input" name="rw-product-name-input" type="number"
                                @wheel="$event.target.blur()" @keypress="isNumber($event)"
                                v-model="$v.form_receipt_reward.quantity.$model"
                                :state="validateRewardModalState('quantity')"
                                aria-describedby="name-live-feedback"></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span v-if="
                                  !$v.form_receipt_reward.quantity.required
                                " class="error">
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>

                          <b-row id="mrw-reward-name" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.POINT"
                                    )
                                  }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="9">
                              <b-form-input id="rw-product-name-input" name="rw-product-name-input" type="number"
                                @wheel="$event.target.blur()" @keypress="isNumber($event)"
                                v-model="$v.form_receipt_reward.point.$model" :state="validateRewardModalState('point')"
                                aria-describedby="name-live-feedback"></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span v-if="!$v.form_receipt_reward.point.required" class="error">
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>

                          <b-row v-if="showRewardMemberTier" id="mrw-reward-member-tier" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>ระดับสมาชิก</h5>
                              </label>
                            </b-col>

                            <b-col sm="9">
                              <treeselect
                                id="rw-member-tier-select"
                                name="rw-member-tier-select"
                                v-model="form_receipt_reward.member_tier_ids"
                                class="reward-member-tier-select"
                                :multiple="true"
                                :options="optionsMemberTier"
                                :clearable="true"
                                :searchable="true"
                                sort-value-by="INDEX"
                                placeholder="เลือกระดับสมาชิก (ไม่ระบุ = ทั้งหมด ทุกระดับแลกได้)"
                                no-options-text="ไม่พบระดับสมาชิก"
                              >
                                <span
                                  slot="value-label"
                                  slot-scope="{ node }"
                                  class="reward-member-tier-chip"
                                  :style="{
                                    backgroundColor: node.raw.color + '20',
                                    color: node.raw.color,
                                    border: `1px solid ${node.raw.color}40`
                                  }"
                                >
                                  {{ node.label }}
                                </span>
                              </treeselect>
                              <small class="text-muted d-block mt-1">
                                * สามารถเลือกได้หลายระดับ หากไม่เลือกจะถือว่าเป็นระดับ "ทั้งหมด" (แลกได้ทุกระดับ)
                              </small>
                            </b-col>
                          </b-row>

                          <b-row id="mrw-reward-name" class="mb-5">
                            <b-col sm="3">
                              <label>
                                <h5>
                                  {{
                                    $t(
                                      "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.DESCRIPTION"
                                    )
                                  }}
                                </h5>
                              </label>
                            </b-col>
                            <b-col sm="9">
                              <ckeditor :editor="editor" v-model="form_receipt_reward.description"
                                :config="editorConfig"></ckeditor>
                            </b-col>
                          </b-row>
                        </form>
                      </b-modal>

                      <p v-if="!disable_form && form.receipt_reward.length == 0" class="ps-note">
                        * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                      </p>

                      <div class="table-responsive">
                        <b-table id="organizations-table" :striped="false" :items="form.receipt_reward"
                          :fields="rewardTableFields" :borderless="false" head-variant="light">
                          <template #cell(quantity)="data">
                            <div class="text-right">
                              <span>{{ data.item.quantity }}</span>
                            </div>
                          </template>

                          <template #cell(member_tier)="data">
                            <div class="text-center">
                              <span v-if="getRewardTierBadges(data.item).length === 0">
                                <b-badge variant="secondary">ทั้งหมด</b-badge>
                              </span>
                              <span v-else>
                                <span
                                  v-for="(tier, idx) in getRewardTierBadges(data.item)"
                                  :key="idx"
                                  class="badge font-weight-bold px-3 py-2 mr-1 mb-1"
                                  :style="{
                                    backgroundColor: tier.color + '20',
                                    color: tier.color,
                                    border: `1px solid ${tier.color}40`
                                  }"
                                >
                                  {{ tier.name }}
                                </span>
                              </span>
                            </div>
                          </template>

                          <template #cell(point)="data">
                            <div class="text-right">
                              <span>{{ data.item.point }}</span>
                            </div>
                          </template>

                          <template #cell(action)="data">
                            <a href="javascript:" @click.prevent="
                              openRewardModal(data.item, data.index)
                              " class="btn btn-icon btn-light btn-sm" :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')
                                ">
                              <span class="svg-icon svg-icon-md svg-icon-success">
                                <inline-svg src=" media/svg/icons/General/Edit.svg"></inline-svg>
                              </span> </a>&nbsp;&nbsp;&nbsp;
                            <a href="javascript:" @click.prevent="removeReceiptReward(data.index)"
                              class="btn btn-icon btn-light btn-sm" :aria-label="$t(
                                'PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE'
                              )
                                ">
                              <span class="svg-icon svg-icon-md svg-icon-danger">
                                <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                              </span>
                            </a>
                          </template>
                        </b-table>

                        <p class="text-center pt-3" v-if="form.receipt_reward.length < 1">
                          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                        </p>
                      </div>
                    </b-tab>

                    <b-tab v-if="id && isProPlanForMembersTab" id="t-segments" :title="$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.SEGMENTS')
                      " lazy>
                      <b-card-text>
                        <CampaignSegmentsTab :campaign_id="id" />
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="id && isProPlanForMembersTab" id="t-members" :title="$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.MEMBERS')
                      " lazy>
                      <b-card-text>
                        <CampaignMembersTab :campaign_id="id" />
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="showQrFeatureTabs && id" id="t-qr-redeem" title="ทำรายการรับแต้ม" lazy>
                      <b-card-text>
                        <CampaignQrSetting :campaign-id="id" />
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="id && form.is_receipt_upload_enabled" id="t-customer" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.CUSTOMER'
                    )
                      " lazy>
                      <b-card-text>
                        <CustomerCampaignReceipt :campaign_id="id" :is_redeem_reward="form.is_redeem_reward"
                          :isTransferSlip="isTransferSlipCompany"></CustomerCampaignReceipt>
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="id && form.is_referral_enabled" id="t-referral" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.REFERRAL'
                    )
                      " lazy>
                      <b-card-text>
                        <CustomerCampaignReferral :campaign_id="id"></CustomerCampaignReferral>
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="showQrFeatureTabs && id" id="t-qr-history" title="ประวัติสแกนแลกแต้ม" lazy>
                      <b-card-text>
                        <CampaignQrHistory :campaign-id="id" />
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="id && form.is_redeem_reward == 1" id="t-receipt-reward" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.RECEIPT_REWARD'
                    )
                      " lazy>
                      <b-card-text>
                        <CustomerCampaignReceiptReward :campaign_id="id" @changing="changeNotApproveReceiptReward">
                        </CustomerCampaignReceiptReward>
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="false" id="t-send-message" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.SEND_MESSAGE'
                    )
                      " lazy>
                      <b-card-text>
                        <CustomerCampaignReceiptSendMessage :campaign_id="id"></CustomerCampaignReceiptSendMessage>
                      </b-card-text>
                    </b-tab>

                    <b-tab v-if="id && form.is_redeem_reward == 0" id="t-announce-reward" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.ANNOUNCEMENT'
                    )
                      " lazy>
                      <CampaignAnnouncement :campaign_id="id" />
                    </b-tab>

                    <b-tab v-if="id" id="t-dashboard" :title="this.$t(
                      'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.DASHBOARD'
                    )
                      " lazy>
                      <CampaignDashboard :key="`campaign-dashboard-${id}`" :campaign_id="id"
                        :plan_slug="companyPlanSlug" :start_date="form.start_date" :end_date="form.end_date"
                        :is_redeem_reward="form.is_redeem_reward" :template="form.template"
                        :is_pro_plan="isProPlanForMembersTab" />
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>

            <!-- Action buttons-->
            <div class="mt-5">
              <b-row v-if="showCampaignFormFooter">
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                    $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                    }}</b-button>
                  <b-button type="submit" variant="primary" class="float-right mr-3">{{
                    $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                    }}</b-button>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_RECEIPT_TYPE } from "@/core/services/store/receipt_type.module";
import {
  FIND_CAMPAIGN,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_ISACTIVE,
  SET_IS_CLEAR_PAGINATION,
  CREATE_CAMPAIGN_RECEIPT_REWARD,
  UPDATE_CAMPAIGN_RECEIPT_REWARD,
  DELETE_CAMPAIGN_RECEIPT_REWARD,
  GET_CAMPAIGN_MEMBER_TIER_OPTIONS
} from "@/core/services/store/campaign.module";
import { GET_COMPANY_MANAGEMENT_DATA } from "@/core/services/store/company_management.module";
import { Config } from "@/core/config/variable.config";
import CustomerCampaignReceipt from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceipt.vue";
import CustomerCampaignReceiptSendMessage from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceiptSendMessage.vue";
import CampaignDashboard from "@/view/pages/campaign/campaign-receipt-form/components/CampaignDashboard.vue";
import CampaignLanding from "@/view/pages/campaign/campaign-receipt-form/components/CampaignLanding.vue";
import CampaignPolicy from "@/view/pages/campaign/campaign-receipt-form/components/CampaignPolicy.vue";
import CustomerCampaignReceiptReward from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceiptReward.vue";
import CustomerCampaignReferral from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReferral.vue";
import CampaignAnnouncement from "@/view/pages/campaign/campaign-receipt-form/components/CampaignAnnouncement.vue";
import CampaignMembersTab from "@/view/pages/campaign/campaign-receipt-form/components/CampaignMembersTab.vue";
import CampaignQrSetting from "@/view/pages/qr-redeem/CampaignQrSetting.vue";
import CampaignQrHistory from "@/view/pages/qr-redeem/CampaignQrHistory.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import AutoImage from "@ckeditor/ckeditor5-image/src/autoimage";
import AutoLink from "@ckeditor/ckeditor5-link/src/autolink";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave";
import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import CloudServices from "@ckeditor/ckeditor5-cloud-services/src/cloudservices";
import Code from "@ckeditor/ckeditor5-basic-styles/src/code";
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock";
import DataFilter from "@ckeditor/ckeditor5-html-support/src/datafilter";
import DataSchema from "@ckeditor/ckeditor5-html-support/src/dataschema";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import FindAndReplace from "@ckeditor/ckeditor5-find-and-replace/src/findandreplace";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize";
import GeneralHtmlSupport from "@ckeditor/ckeditor5-html-support/src/generalhtmlsupport";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";
import HtmlComment from "@ckeditor/ckeditor5-html-support/src/htmlcomment";
import HtmlEmbed from "@ckeditor/ckeditor5-html-embed/src/htmlembed";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageInsert from "@ckeditor/ckeditor5-image/src/imageinsert";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Link from "@ckeditor/ckeditor5-link/src/link";
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage";
import List from "@ckeditor/ckeditor5-list/src/list";
import ListProperties from "@ckeditor/ckeditor5-list/src/listproperties";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import MediaEmbedToolbar from "@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar";
import Mention from "@ckeditor/ckeditor5-mention/src/mention";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat";
import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting";
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters";
import SpecialCharactersArrows from "@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows";
import SpecialCharactersCurrency from "@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency";
import SpecialCharactersEssentials from "@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials";
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin";
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical";
import SpecialCharactersText from "@ckeditor/ckeditor5-special-characters/src/specialcharacterstext";
import StandardEditingMode from "@ckeditor/ckeditor5-restricted-editing/src/standardeditingmode";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableCaption from "@ckeditor/ckeditor5-table/src/tablecaption";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import TextPartLanguage from "@ckeditor/ckeditor5-language/src/textpartlanguage";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation";
import TodoList from "@ckeditor/ckeditor5-list/src/todolist";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";
import EmojiActivity from "@/core/plugins/emoji-activity";
import EmojiFlags from "@/core/plugins/emoji-flags";
import EmojiFood from "@/core/plugins/emoji-food";
import EmojiNature from "@/core/plugins/emoji-nature";
import EmojiObjects from "@/core/plugins/emoji-objects";
import EmojiPeople from "@/core/plugins/emoji-people";
import EmojiPlaces from "@/core/plugins/emoji-places";
import EmojiSymbols from "@/core/plugins/emoji-symbols";
import { rewardTierBadges } from "@/core/services/member-tier.helper";

export default {
  name: "CampaignReceiptForm",
  mixins: [validationMixin],
  components: {
    CustomerCampaignReceipt,
    CustomerCampaignReceiptReward,
    CustomerCampaignReferral,
    CustomerCampaignReceiptSendMessage,
    CampaignDashboard,
    CampaignLanding,
    CampaignPolicy,
    datePicker,
    CampaignAnnouncement,
    CampaignMembersTab,
    CampaignQrSetting,
    CampaignQrHistory,
    /** Async avoids circular init (ApiService → router) breaking static SFC import. */
    CampaignSegmentsTab: () =>
      import(
        "@/view/pages/campaign/campaign-receipt-form/components/CampaignSegmentsTab.vue"
      )
  },
  data() {
    return {
      ADMIN_IMAGE_URL: Config.ADMIN_IMAGE_URL,
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          Base64UploadAdapter,
          BlockQuote,
          Bold,
          CloudServices,
          Code,
          CodeBlock,
          DataFilter,
          DataSchema,
          Essentials,
          FindAndReplace,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          Highlight,
          HorizontalLine,
          HtmlComment,
          HtmlEmbed,
          Image,
          ImageCaption,
          ImageInsert,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          MediaEmbedToolbar,
          Mention,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SourceEditing,
          SpecialCharacters,
          EmojiPeople,
          EmojiFood,
          EmojiPlaces,
          EmojiActivity,
          EmojiFlags,
          EmojiNature,
          EmojiObjects,
          EmojiSymbols,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          StandardEditingMode,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableProperties,
          TableToolbar,
          TextPartLanguage,
          TextTransformation,
          TodoList,
          Underline,
          WordCount
        ],
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "underline",
            "italic",
            "strikethrough",
            "|",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "fontFamily",
            "|",
            "link",
            "imageUpload",
            "mediaEmbed",
            "insertTable",
            "specialCharacters",
            "|",
            "undo",
            "redo",
            "-",
            "horizontalLine",
            "pageBreak",
            "superscript",
            "subscript",
            "highlight",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "alignment",
            "outdent",
            "indent",
            "removeFormat",
            "blockQuote"
          ],
          shouldNotGroupWhenFull: true
        },
        language: "en",
        image: {
          toolbar: [
            "imageTextAlternative",
            "imageStyle:inline",
            "imageStyle:block",
            "imageStyle:side",
            "linkImage"
          ]
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties"
          ]
        }
      },
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      /** Index ของแท็บที่เปิด (b-tabs v-model) — 0=ทั่วไป, 1=ประเภทใบเสร็จ, … */
      campaign_active_tab_index: 0,
      id: null,
      preview: {
        image_default: "media/default_image.png",
        image: null,
        images: []
      },
      disable_form: false,
      isSubmit: false,
      /** When false, the rich-text "detail" row is hidden and detail is optional. */
      showCampaignDetailField: false,
      /** When false, the campaign primary image upload row is hidden. */
      showCampaignMainImageField: false,
      showProductTab: false,
      form: {
        campaign_type_id: 1,
        liff_id: null,
        liff_id_before_loading: null,
        line_message_token: null,
        code: null,
        name: null,
        detail: null,
        start_date: null,
        end_date: null,
        is_active: false,
        is_redeem_reward: 0,
        term_and_condition: null,
        image: null,
        image_file: [],
        images: [],
        images_file: [],
        images_delete: [],
        receipt_type: [],
        receipt_product: [],
        receipt_product_delete: [],
        receipt_reward: [],
        receipt_reward_delete: [],
        landing_image: null,
        new_landing_image: null,
        new_landing_image_src: null,
        policy_image: null,
        policy: null,
        policy_not_accept: null,
        is_enable_value_based_points: false,
        is_qr_scan_enabled: false,
        is_receipt_upload_enabled: true,
        is_staff_qr_scan_enabled: false,
        value_based_amount: null,
        value_based_points: null,
        is_referral_enabled: false,
        referral_inviter_point: 0,
        referral_invitee_point: 0,
        plan_slug: null,
        receipt_verify_regex: null,
        ocr_item_filter_prompt: "",
        receipt_duplicate_prompt: "",
        approval_criteria_prompt: "",
        is_mode_login: 0
      },
      ocrFilterPromptRefining: false,
      receiptDuplicatePromptRefining: false,
      approvalCriteriaPromptRefining: false,
      liff_client_url: null,
      receipt_selection: "all",
      receipt_selection_option: [
        { item: "all", name: this.$t("PAGE.DEFAULT.FORM.OPTIONS.ALL") },
        { item: "custom", name: this.$t("PAGE.DEFAULT.FORM.OPTIONS.CUSTOM") }
      ],
      optionsType: [
        { value: 0, text: "lucky" },
        { value: 1, text: "reward" }
      ],
      optionsModeOfCampaign: [
        { value: 0, text: "lineLogin" },
        { value: 1, text: "OTP Login" }
      ],
      receipt_list: [],
      is_receipt_type_conpany: null,
      is_transfer_slip: null,
      is_member_tier_enabled: null,
      companyPlanSlug: null,
      companyName: null,
      form_receipt_product: {
        is_edit: false,
        index: null,
        product_name: "",
        quantity: "",
        point: 1
      },
      table_receipt_product: {
        fields: [
          {
            key: "product_name",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
            key_table: "product_name",
            sortable: false,
            isFilter: false
          },
          {
            key: "quantity",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.QUANTITY")}`,
            tdClass: "text-right",
            thClass: "text-right",
            key_table: "quantity",
            sortable: false,
            isFilter: false
          },
          {
            key: "point",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.POINT")}`,
            tdClass: "text-right",
            thClass: "text-right",
            key_table: "point",
            sortable: false,
            isFilter: false
          },
          {
            key: "action",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
            sortable: false,
            isFilter: false,
            tdClass: "actionField"
          }
        ]
      },
      form_receipt_reward: {
        is_edit: false,
        index: null,
        reward_name: "",
        quantity: "0",
        point: "0",
        member_tier_id: null,
        member_tier_ids: [],
        image: null,
        newImage: null,
        description: null
      },
      /** ระดับสมาชิกที่เปิดใช้งานของบริษัทเจ้าของแคมเปญ (จาก GET member_tier) — ว่าง = บริษัทไม่ได้ใช้ระดับสมาชิก */
      memberTiers: [],
      table_receipt_reward: {
        fields: [
          {
            key: "reward_name",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
            key_table: "reward_name",
            sortable: false,
            isFilter: false
          },
          {
            key: "quantity",
            label: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.QUANTITY")}`,
            key_table: "quantity",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          },
          {
            key: "member_tier",
            label: "ระดับสมาชิก",
            key_table: "member_tier",
            tdClass: "text-center",
            thClass: "text-center",
            sortable: false,
            isFilter: false
          },
          {
            key: "point",
            label: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.POINT")}`,
            key_table: "point",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          },
          {
            key: "action",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
            sortable: false,
            isFilter: false,
            tdClass: "actionField"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(256)
      },
      detail: {
        required: requiredIf(function () {
          return this.showCampaignDetailField;
        })
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      is_redeem_reward: {
        required
      },
      is_mode_login: {
        required
      },
      term_and_condition: {},
      receipt_type: {
        required: requiredIf(function () {
          return !this.isTransferSlipCompany;
        })
      },
      receipt_product: {
        required: requiredIf(function () {
          return this.showProductTab;
        })
      },
      receipt_reward: {
        required
      },
      new_landing_image: {
        required: requiredIf(function () {
          return !this.form.new_landing_image && !this.form.landing_image;
        })
      },
      policy: {
        required
      },
      policy_not_accept: {
        required
      },
      value_based_amount: {
        required: requiredIf(function () {
          return (
            this.showValueBasedPointsSection &&
            !!this.form.is_enable_value_based_points
          );
        }),
        minAmount(value) {
          if (
            !this.showValueBasedPointsSection ||
            !this.form.is_enable_value_based_points
          ) {
            return true;
          }
          if (value === "" || value === null || value === undefined) {
            return true;
          }
          const n = Number(value);
          return !isNaN(n) && n >= 0.01;
        }
      },
      value_based_points: {
        required: requiredIf(function () {
          return (
            this.showValueBasedPointsSection &&
            !!this.form.is_enable_value_based_points
          );
        }),
        minPoints(value) {
          if (
            !this.showValueBasedPointsSection ||
            !this.form.is_enable_value_based_points
          ) {
            return true;
          }
          if (value === "" || value === null || value === undefined) {
            return true;
          }
          const n = parseInt(value, 10);
          return !isNaN(n) && n >= 1;
        }
      }
    },
    form_receipt_product: {
      product_name: {
        required,
        maxLength: maxLength(256)
      },
      quantity: {
        required
      },
      point: {
        required
      }
    },
    form_receipt_reward: {
      reward_name: {
        required,
        maxLength: maxLength(512)
      },
      quantity: {
        required,
        maxLength: maxLength(512)
      },
      point: {
        required,
        maxLength: maxLength(512)
      },
      newImage: {
        required: requiredIf(function () {
          return (
            !this.form_receipt_reward.newImage &&
            !this.form_receipt_reward.image
          );
        })
      }
    }
  },
  computed: {
    ...mapState({
      currentUserData: (state) => state.auth.currentUserData,
      userType: (state) => state.auth.userType
    }),
    isSuperAdmin() {
      const u = this.currentUserData || {};
      const raw =
        this.userType !== "" && this.userType != null
          ? this.userType
          : u.user_type_id != null
          ? u.user_type_id
          : u.userType && u.userType.id;
      return Number(raw) === 1;
    },
    /** ช่องและคอลัมน์ระดับสมาชิกของของรางวัล แสดงเฉพาะบริษัทที่มีระดับสมาชิกให้เลือก */
    showRewardMemberTier() {
      return this.memberTiers.length > 0;
    },
    optionsMemberTier() {
      return this.memberTiers.map((tier) => ({
        id: tier.id,
        label: tier.name,
        color: tier.color || "#3699FF"
      }));
    },
    rewardTableFields() {
      return this.showRewardMemberTier
        ? this.table_receipt_reward.fields
        : this.table_receipt_reward.fields.filter(
            (field) => field.key !== "member_tier"
          );
    },
    /** Start/end date are locked for non super admin when editing an existing campaign. */
    disable_date_form() {
      return this.disable_form || (!!this.id && !this.isSuperAdmin);
    },
    /** Same audience as the OCR prompt fields: super admin always; others when campaign is not locked active. */
    canShowAiRefinePromptButtons() {
      return this.isSuperAdmin || !this.disable_form;
    },
    ocrItemFilterPromptHasText() {
      return String(this.form.ocr_item_filter_prompt || "").trim().length > 0;
    },
    receiptDuplicatePromptHasText() {
      return String(this.form.receipt_duplicate_prompt || "").trim().length > 0;
    },
    approvalCriteriaPromptHasText() {
      return String(this.form.approval_criteria_prompt || "").trim().length > 0;
    },
    selectedReceiptTypeCount() {
      return this.extractReceiptTypeIds(this.form.receipt_type).length;
    },
    showValueBasedPointsSection() {
      if (this.companyPlanSlug === null || this.companyPlanSlug === undefined) {
        return false;
      }
      const slug = String(this.companyPlanSlug).toLowerCase().trim();
      const isPlanAllowed = slug === "growth" || slug === "pro";
      return isPlanAllowed;
    },
    showQrFeatureTabs() {
      return !!this.form.is_qr_scan_enabled;
    },
    /** Same plan gate as value-based points: `growth` / `pro` (see plans.slug). Uses form.plan_slug with company fallback for new campaigns. */
    showReceiptVerifyRegexField() {
      const raw =
        this.form.plan_slug != null && this.form.plan_slug !== ""
          ? this.form.plan_slug
          : this.companyPlanSlug;
      if (raw === null || raw === undefined || raw === "") {
        return false;
      }
      const slug = String(raw).toLowerCase().trim();
      return slug === "growth" || slug === "pro";
    },
    /** Same plan gate as the OCR/receipt-verify fields: `growth` / `pro`. Uses form.plan_slug with company fallback. */
    showReceiptDuplicatePromptField() {
      const raw =
        this.form.plan_slug != null && this.form.plan_slug !== ""
          ? this.form.plan_slug
          : this.companyPlanSlug;
      if (raw === null || raw === undefined || raw === "") {
        return false;
      }
      const slug = String(raw).toLowerCase().trim();
      return slug === "growth" || slug === "pro";
    },
    /** Same plan gate as the other AI-prompt fields: `growth` / `pro`. Uses form.plan_slug with company fallback. */
    showApprovalCriteriaPromptField() {
      const raw =
        this.form.plan_slug != null && this.form.plan_slug !== ""
          ? this.form.plan_slug
          : this.companyPlanSlug;
      if (raw === null || raw === undefined || raw === "") {
        return false;
      }
      const slug = String(raw).toLowerCase().trim();
      return slug === "growth" || slug === "pro";
    },
    /** Pro plan only — not Growth/Starter (สมาชิก tab). Mirrors effective plan_slug with company fallback. */
    isProPlanForMembersTab() {
      const raw =
        this.form.plan_slug != null && this.form.plan_slug !== ""
          ? this.form.plan_slug
          : this.companyPlanSlug;
      if (raw === null || raw === undefined || raw === "") {
        return false;
      }
      return String(raw).toLowerCase().trim() === "pro";
    },
    /** แท็บสุดท้ายในชุดฟอร์มหลักก่อนแท็บลูกค้า/ดาชบอร์ด (ทั่วไป → ประเภทใบเสร็จ → [สินค้า] → ของรางวัล) */
    lastFormEditTabIndex() {
      if (this.isTransferSlipCompany) {
        return this.showProductTab ? 2 : 1;
      }
      return this.showProductTab ? 3 : 2;
    },
    isTransferSlipCompany() {
      return Number(this.is_transfer_slip) === 1;
    },
    showReceiptTypeTab() {
      return !this.isTransferSlipCompany;
    },
    /** แท็บที่ต้องมีปุ่มตกลง/ยกเลิกด้านล่าง (ไม่รวมแท็บของรางวัล) */
    is_submit() {
      const idx = this.campaign_active_tab_index;
      return idx >= 0 && idx <= this.lastFormEditTabIndex;
    },
    showCampaignFormFooter() {
      return (
        this.is_submit &&
        this.campaign_active_tab_index !== this.lastFormEditTabIndex
      );
    }
  },
  watch: {
    showValueBasedPointsSection(val, oldVal) {
      if (oldVal === true && val === false) {
        this.resetValueBasedPointsWhenPlanRestricted();
      }
    },
    showReceiptVerifyRegexField(val, oldVal) {
      if (oldVal === true && val === false) {
        this.form.receipt_verify_regex = null;
      }
    },
    showReceiptDuplicatePromptField(val, oldVal) {
      if (oldVal === true && val === false) {
        this.$set(this.form, "receipt_duplicate_prompt", "");
      }
    },
    // หน้าเพิ่ม/แก้ไขใช้ component ตัวเดียวกัน เปลี่ยน route โดยไม่ reload Vue จะไม่ mount ใหม่
    // ต้องล้างฟอร์มแล้วโหลดใหม่เอง ไม่งั้น id ของแคมเปญเดิมค้าง กดบันทึกหน้าเพิ่มจะ PUT ทับแคมเปญเดิม
    $route(to, from) {
      if (
        to.path !== from.path ||
        to.params.id !== from.params.id ||
        to.params.companyId !== from.params.companyId ||
        to.query.companyId !== from.query.companyId
      ) {
        this.resetPage();
        this.initPage();
      }
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    /** คืน data ทั้งหมดเป็นค่าเริ่มต้น (ยกเว้นตัว editor ที่ผูกกับ CKEditor ที่ mount อยู่แล้ว) */
    resetPage() {
      const fresh = this.$options.data.call(this);
      delete fresh.editor;
      delete fresh.editorConfig;
      Object.assign(this.$data, fresh);
      this.$v.$reset();
    },
    async initPage() {
      const routeCompanyId = this.$route.params.companyId
        ? Number(this.$route.params.companyId)
        : this.$route.query.companyId
        ? Number(this.$route.query.companyId)
        : null;
      const campaignListRoute = routeCompanyId
        ? `/company-management/${routeCompanyId}/campaign`
        : "/campaign";
      const breadcrumbs = [];
      if (routeCompanyId) {
        breadcrumbs.push({
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "/company-management",
        });
      }
      breadcrumbs.push(
        {
          title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
          route: campaignListRoute,
        },
        {
          title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`,
        }
      );
      this.$store.dispatch(SET_BREADCRUMB, breadcrumbs);
      this.id = this.$route.params.id;
      await this.loadCompanyReceiptTypeConfig(routeCompanyId);
      await this.getReceiptType();

      if (this.id) {
        await this.getCampaign(this.id);
        await this.loadCompanyReceiptTypeConfig(
          this.form.company_id != null ? this.form.company_id : null
        );
        // Re-set breadcrumb with company context from loaded campaign
        if (routeCompanyId && this.form.company_id) {
          const cId = this.form.company_id;
          this.$store.dispatch(SET_BREADCRUMB, [
            {
              title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
              route: "/company-management",
            },
            {
              title: this.companyName || `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
            },
            {
              title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
              route: `/company-management/${cId}/campaign`,
            },

            {
              title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`,
            },
          ]);
        }
      } else if (routeCompanyId) {
        this.form.company_id = routeCompanyId;
      }
      await this.loadMemberTiers();
    },
    /** ตัวเลือกระดับสมาชิกของบริษัทเจ้าของแคมเปญ ใช้ผูกของรางวัลกับระดับ */
    async loadMemberTiers() {
      const companyId =
        this.form.company_id != null && this.form.company_id !== ""
          ? Number(this.form.company_id)
          : this.getCurrentCompanyId();
      if (this.is_member_tier_enabled === null && companyId) {
        await this.loadCompanyReceiptTypeConfig(companyId);
      }
      if (!this.isCompanyMemberTierEnabled()) {
        this.memberTiers = [];
        return;
      }
      try {
        const { data } = await this.$store.dispatch(
          GET_CAMPAIGN_MEMBER_TIER_OPTIONS,
          { params: companyId ? { company_id: companyId } : {} }
        );
        const items =
          data && data.status === "success" && data.data
            ? data.data.items
            : null;
        this.memberTiers = Array.isArray(items)
          ? items.filter((tier) => Number(tier.status_id) === 1)
          : [];
      } catch (error) {
        this.memberTiers = [];
      }
    },
    async loadCompanyReceiptTypeConfig(companyIdOverride) {
      const companyId =
        companyIdOverride != null && companyIdOverride !== ""
          ? Number(companyIdOverride)
          : this.getCurrentCompanyId();
      if (!companyId) {
        return;
      }

      try {
        const { data } = await this.$store.dispatch(
          GET_COMPANY_MANAGEMENT_DATA,
          {
            id: companyId
          }
        );
        if (data.status === "success" && data.data) {
          this.is_receipt_type_conpany = data.data.is_receipt_type_conpany;
          this.is_transfer_slip = data.data.is_transfer_slip;
          if (data.data.is_member_tier_enabled !== undefined) {
            this.is_member_tier_enabled = Number(data.data.is_member_tier_enabled) === 1;
          }
          if (data.data.name) {
            this.companyName = data.data.name;
          }
          if (data.data.plan_slug != null && data.data.plan_slug !== "") {
            this.companyPlanSlug = data.data.plan_slug;
          } else {
            this.companyPlanSlug = "starter";
          }
          this.form.plan_slug = this.companyPlanSlug;
        }
      } catch (error) {
        // Keep fallback from auth payload if request fails.
      }
    },
    copyText(id) {
      let copyText = document.getElementById(id);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");

      Swal.fire({
        icon: "success",
        title: "คัดลอกข้อความเรียบร้อย",
        showConfirmButton: false,
        timer: 1000
      });
    },
    changeNotApproveReceiptReward() {
      this.getCampaign(this.id);
    },
    onChangeTabs() {
      // console.log(value);
    },
    isNumber(event) {
      if (
        !(
          event.key === "Enter" ||
          (Number(event.key) >= 0 && Number(event.key) <= 9)
        )
      ) {
        return event.preventDefault();
      }
    },
    async refineOcrFilterPromptWithAi() {
      const raw = (this.form.ocr_item_filter_prompt || '').trim()
      if (!raw) return
      this.ocrFilterPromptRefining = true
      try {
        const { data } = await this.$store.dispatch('refineOcrFilterPrompt', { text: raw })
        if (data && data.status === 'success' && data.data && data.data.refined_prompt) {
          this.$set(this.form, 'ocr_item_filter_prompt', data.data.refined_prompt)
        }
      } catch (e) {
        // silent fail — user keeps original text
      } finally {
        this.ocrFilterPromptRefining = false
      }
    },
    async refineReceiptDuplicatePromptWithAi() {
      const raw = (this.form.receipt_duplicate_prompt || '').trim()
      if (!raw) return
      this.receiptDuplicatePromptRefining = true
      try {
        const { data } = await this.$store.dispatch('refineReceiptDuplicatePrompt', { text: raw })
        if (data && data.status === 'success' && data.data && data.data.refined_prompt) {
          this.$set(this.form, 'receipt_duplicate_prompt', data.data.refined_prompt)
        }
      } catch (e) {
        // silent fail — user keeps original text
      } finally {
        this.receiptDuplicatePromptRefining = false
      }
    },
    async refineApprovalCriteriaPromptWithAi() {
      const raw = (this.form.approval_criteria_prompt || '').trim()
      if (!raw) return
      this.approvalCriteriaPromptRefining = true
      try {
        const { data } = await this.$store.dispatch('refineApprovalCriteriaPrompt', { text: raw })
        if (data && data.status === 'success' && data.data && data.data.refined_prompt) {
          this.$set(this.form, 'approval_criteria_prompt', data.data.refined_prompt)
        }
      } catch (e) {
        // silent fail — user keeps original text
      } finally {
        this.approvalCriteriaPromptRefining = false
      }
    },
    onValueBasedPointsToggle() {
      this.$nextTick(() => {
        if (!this.form.is_enable_value_based_points) {
          this.form.value_based_amount = null;
          this.form.value_based_points = null;
          if (this.$v.form.value_based_amount) {
            this.$v.form.value_based_amount.$reset();
          }
          if (this.$v.form.value_based_points) {
            this.$v.form.value_based_points.$reset();
          }
        }
      });
    },
    resetValueBasedPointsWhenPlanRestricted() {
      this.form.is_enable_value_based_points = false;
      this.form.value_based_amount = null;
      this.form.value_based_points = null;
      this.$nextTick(() => {
        if (this.$v.form.value_based_amount) {
          this.$v.form.value_based_amount.$reset();
        }
        if (this.$v.form.value_based_points) {
          this.$v.form.value_based_points.$reset();
        }
      });
    },
    prepareCampaignPayload(form) {
      const p = { ...form };
      p.is_qr_scan_enabled = form.is_qr_scan_enabled ? 1 : 0;
      p.is_receipt_upload_enabled = form.is_receipt_upload_enabled ? 1 : 0;
      p.is_staff_qr_scan_enabled = form.is_staff_qr_scan_enabled ? 1 : 0;
      const d = p.detail;
      if (d == null || (typeof d === "string" && d.trim() === "")) {
        p.detail = "";
      } else if (typeof d === "string") {
        p.detail = d.trim();
      }
      // referral (แนะนำเพื่อน) — normalize ก่อนส่ง (อยู่ก่อน early return ของ value-based)
      p.is_referral_enabled = form.is_referral_enabled ? 1 : 0;
      if (!form.is_referral_enabled) {
        p.referral_inviter_point = 0;
        p.referral_invitee_point = 0;
      } else {
        p.referral_inviter_point = parseInt(form.referral_inviter_point, 10) || 0;
        p.referral_invitee_point = parseInt(form.referral_invitee_point, 10) || 0;
      }
      if (!this.showReceiptVerifyRegexField) {
        p.receipt_verify_regex = null;
      } else {
        const rx = form.receipt_verify_regex;
        p.receipt_verify_regex =
          rx === "" || rx === null || rx === undefined
            ? null
            : String(rx).trim() || null;
      }
      if (!this.showReceiptDuplicatePromptField) {
        p.receipt_duplicate_prompt = null;
      } else {
        const dp = form.receipt_duplicate_prompt;
        p.receipt_duplicate_prompt =
          dp === "" || dp === null || dp === undefined
            ? null
            : String(dp).trim() || null;
      }
      if (!this.showApprovalCriteriaPromptField) {
        p.approval_criteria_prompt = null;
      } else {
        const ap = form.approval_criteria_prompt;
        p.approval_criteria_prompt =
          ap === "" || ap === null || ap === undefined
            ? null
            : String(ap).trim() || null;
      }
      if (!this.showValueBasedPointsSection) {
        p.is_enable_value_based_points = 0;
        p.value_based_amount = null;
        p.value_based_points = null;
        return p;
      }
      p.is_enable_value_based_points = form.is_enable_value_based_points
        ? 1
        : 0;
      if (!form.is_enable_value_based_points) {
        p.value_based_amount = null;
        p.value_based_points = null;
      } else {
        const amt = form.value_based_amount;
        const pts = form.value_based_points;
        p.value_based_amount =
          amt === "" || amt === null || amt === undefined ? null : Number(amt);
        p.value_based_points =
          pts === "" || pts === null || pts === undefined
            ? null
            : parseInt(pts, 10);
      }
      return p;
    },
    async toggleIsActive() {
      await this.$nextTick();
      this.form.is_active = !this.form.is_active;
      Swal.fire({
        html: `${this.form.is_active
            ? this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFRIM_DISABLE")
            : this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFRIM_ENABLE")
          }`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.is_active = !this.form.is_active;
          this.updateDataIsActive({ is_active: this.form.is_active }, this.id);
        }
      });
    },
    getCampaign(id) {
      return this.$store
        .dispatch(FIND_CAMPAIGN, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form = data.data;
            if (Array.isArray(this.form.receipt_reward)) {
              this.form.receipt_reward = this.form.receipt_reward.map((row) =>
                this.normalizeRewardFromApi(row)
              );
            }
            this.form.is_active = !!data.data.is_active;
            this.form.is_referral_enabled = !!data.data.is_referral_enabled;
            this.disable_form = this.form.is_active;

            this.form.liff_id_before_loading = data.data.liff_id;
            this.liff_client_url = `${Config.SWEEPSTAKES_LIFF_CLIENT_URL}/?id=${this.form.code}`;

            if (data.data.image) {
              this.preview.image = `${Config.ADMIN_IMAGE_URL}/${data.data.image}`;
            }

            for (let data of data.data.images) {
              data.image = `${Config.ADMIN_IMAGE_URL}/${data.image}`;
            }
            this.preview.images = [...data.data.images];

            // set other images.
            this.form.image = null;
            this.form.is_mode_login = this.form.is_mode_login
              ? this.form.is_mode_login
              : 0;
            this.form.is_redeem_reward = data.data.is_redeem_reward
              ? data.data.is_redeem_reward
              : 0;
            this.form.image_file = null;
            this.form.images_file = [];
            this.form.images_delete = [];
            this.form.receipt_product_delete = [];
            this.form.receipt_reward_delete = [];

            this.form.images = [...data.data.images];

            // set date time
            this.form.start_date = new Date(data.data.start_date);
            this.form.end_date = new Date(data.data.end_date);

            for (const key in this.form.receipt_type) {
              this.form.receipt_type[key] = {
                receipt_type_id: this.form.receipt_type[key].receipt_type_id
              };
            }

            this.syncReceiptSelectionForEdit();

            if (data.data.plan_slug != null && data.data.plan_slug !== "") {
              this.companyPlanSlug = data.data.plan_slug;
            } else {
              this.companyPlanSlug = "starter";
            }

            const backendValueBasedEnabled = data.data.is_enable_value_based_points;
            this.form.is_enable_value_based_points =
              backendValueBasedEnabled === undefined || backendValueBasedEnabled === null
                ? false
                : !!(
                    backendValueBasedEnabled === 1 ||
                    backendValueBasedEnabled === true ||
                    backendValueBasedEnabled === "1"
                  );

            const backendQrEnabled = data.data.is_qr_scan_enabled;
            this.form.is_qr_scan_enabled =
              backendQrEnabled === undefined || backendQrEnabled === null
                ? false
                : !!(
                    backendQrEnabled === 1 ||
                    backendQrEnabled === true ||
                    backendQrEnabled === "1"
                  );

            const backendReceiptUploadEnabled = data.data.is_receipt_upload_enabled;
            this.form.is_receipt_upload_enabled =
              backendReceiptUploadEnabled === undefined || backendReceiptUploadEnabled === null
                ? true
                : !!(
                    backendReceiptUploadEnabled === 1 ||
                    backendReceiptUploadEnabled === true ||
                    backendReceiptUploadEnabled === "1"
                  );
            this.form.is_staff_qr_scan_enabled =
              !!data.data.is_staff_qr_scan_enabled;
            if (this.form.value_based_amount === undefined) {
              this.form.value_based_amount = null;
            }
            if (this.form.value_based_points === undefined) {
              this.form.value_based_points = null;
            }
            if (this.form.receipt_verify_regex === undefined) {
              this.form.receipt_verify_regex = null;
            }
            this.$set(
              this.form,
              "ocr_item_filter_prompt",
              data.data.ocr_item_filter_prompt == null
                ? ""
                : String(data.data.ocr_item_filter_prompt)
            );
            this.$set(
              this.form,
              "receipt_duplicate_prompt",
              data.data.receipt_duplicate_prompt == null
                ? ""
                : String(data.data.receipt_duplicate_prompt)
            );
            this.$set(
              this.form,
              "approval_criteria_prompt",
              data.data.approval_criteria_prompt == null
                ? ""
                : String(data.data.approval_criteria_prompt)
            );
            if (
              this.form.plan_slug === undefined ||
              this.form.plan_slug === null ||
              this.form.plan_slug === ""
            ) {
              this.form.plan_slug = this.companyPlanSlug;
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    getReceiptType() {
      const isReceiptTypeConpanyEnabled = this.isReceiptTypeConpanyEnabled();
      const companyId = this.getCurrentCompanyId();

      return this.$store
        .dispatch(GET_RECEIPT_TYPE)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            let receiptRows = Array.isArray(data.data) ? data.data : [];

            if (!isReceiptTypeConpanyEnabled) {
              receiptRows = receiptRows.filter(
                (receipt) => Number(receipt.company_id) === Number(companyId)
              );
            }

            this.receipt_list = receiptRows.map((receipt) => ({
              text: receipt.name,
              value: { receipt_type_id: receipt.id }
            }));

            if (!this.id) {
              this.receipt_selection = isReceiptTypeConpanyEnabled
                ? "all"
                : "custom";
              this.setReceiptSelection(this.receipt_selection);
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    isReceiptTypeConpanyEnabled() {
      if (this.is_receipt_type_conpany !== null) {
        return this.parseReceiptTypeCompanyFlag(this.is_receipt_type_conpany);
      }
      const company = this.currentUserData
        ? this.currentUserData.company
        : null;
      if (!company || company.is_receipt_type_conpany === undefined) {
        return true;
      }
      return this.parseReceiptTypeCompanyFlag(company.is_receipt_type_conpany);
    },
    parseReceiptTypeCompanyFlag(value) {
      return value === 1 || value === "1" || value === true;
    },
    isCompanyMemberTierEnabled() {
      if (this.is_member_tier_enabled !== null) {
        return this.is_member_tier_enabled === true || Number(this.is_member_tier_enabled) === 1;
      }
      const company = this.currentUserData
        ? this.currentUserData.company
        : null;
      if (!company || company.is_member_tier_enabled === undefined) {
        return false;
      }
      return Number(company.is_member_tier_enabled) === 1;
    },
    getCurrentCompanyId() {
      const u = this.currentUserData;
      if (!u) {
        return null;
      }
      if (u.company_id != null && u.company_id !== "") {
        return Number(u.company_id);
      }
      const company = u.company;
      if (!company) {
        return null;
      }
      return company.id || company.company_id || null;
    },
    setDefaultImage() {
      this.preview.image = null;
      this.preview.images = [];
    },
    handleMainImage(e) {
      const selectImage = e.target.files[0];

      if (selectImage != undefined) {
        this.encodeBase64(selectImage, "main");
      } else {
        this.setDefaultImage();
      }
    },
    handleBannerImage(e) {
      const selectImage = e.target.files[0];

      if (selectImage != undefined) {
        this.encodeBase64(selectImage, "other");
      } else {
        this.setDefaultImage();
      }
    },
    async handleReceiptRewardImage(event) {
      try {
        let source = await this.toBase64(event);
        if (source) {
          this.$v.form_receipt_reward.newImage.$model = source[0];
        }
      } catch (error) {
        //console.log(error);
      }
    },
    toBase64(event) {
      return new Promise((resolve, reject) => {
        try {
          let index = 0;
          let fileResult = [];
          const reader = new FileReader();
          reader.onload = (e) => {
            fileResult.push(e.target.result);
            index++;
            if (index == event.target.files.length) {
              this.$refs["file-input"].reset();
              resolve(fileResult);
            }
          };
          for (const file of event.target.files) {
            reader.readAsDataURL(file);
          }
        } catch (error) {
          reject(error.toString());
        }
      });
    },
    encodeBase64(file, type) {
      const reader = new FileReader();

      switch (type) {
        case "main":
          reader.onload = (e) => {
            this.form.image = e.target.result;
            this.preview.image = e.target.result;
          };
          break;
        case "other":
          reader.onload = (e) => {
            this.form.image_file = null;
            this.form.images.push({ image: e.target.result });
            this.preview.images.push({ image: e.target.result });
          };
          break;
      }

      reader.readAsDataURL(file);
    },
    onReceiptSelectionChanged(value) {
      this.setReceiptSelection(value);
    },
    syncReceiptSelectionForEdit() {
      const availableIds = this.extractReceiptTypeIds(this.receipt_list);
      const selectedIds = this.extractReceiptTypeIds(this.form.receipt_type);

      if (!availableIds.length) {
        this.form.receipt_type = [];
        return;
      }

      const selectedIdSet = new Set(selectedIds);
      const isSelectAllAvailable = availableIds.every((id) =>
        selectedIdSet.has(id)
      );
      this.receipt_selection = isSelectAllAvailable ? "all" : "custom";

      // Keep only currently available receipt types for cleaner edit UX.
      this.form.receipt_type = selectedIds
        .filter((id) => availableIds.includes(id))
        .map((id) => ({ receipt_type_id: id }));
    },
    extractReceiptTypeIds(items = []) {
      if (!Array.isArray(items)) {
        return [];
      }
      return items
        .map((item) => this.getReceiptTypeId(item))
        .filter((id) => Number.isFinite(id));
    },
    getReceiptTypeId(item) {
      if (item && typeof item === "object") {
        if (
          item.receipt_type_id !== undefined &&
          item.receipt_type_id !== null
        ) {
          return Number(item.receipt_type_id);
        }

        if (item.value && typeof item.value === "object") {
          const nestedValue = item.value.receipt_type_id;
          if (nestedValue !== undefined && nestedValue !== null) {
            return Number(nestedValue);
          }
        }

        if (item.value !== undefined && item.value !== null) {
          return Number(item.value);
        }
      }

      return Number(item);
    },
    setReceiptSelection(e) {
      if (e === "all") {
        this.form.receipt_type = [];

        for (const receipt of this.receipt_list) {
          this.form.receipt_type.push(receipt.value);
        }
      }
    },
    clearAllReceiptTypes() {
      if (this.receipt_selection !== "custom" || this.disable_form) {
        return;
      }
      this.form.receipt_type = [];
    },
    openProductModal(data = null, index = null) {
      if (data) {
        this.form_receipt_product.product_name = data.product_name;
        this.form_receipt_product.quantity = data.quantity;
        this.form_receipt_product.point = data.point;
        this.form_receipt_product.index = index;
      }

      this.$bvModal.show("modal-product-form");
    },
    validateProductModalState(name) {
      const { $dirty, $error } = this.$v.form_receipt_product[name];
      return $dirty ? !$error : null;
    },
    handleSubmitProduct(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$v.form_receipt_product.$touch();

      if (this.$v.form_receipt_product.$anyError) {
        return;
      }

      this.handleSaveProduct();
    },
    handleSaveProduct() {
      if (this.form_receipt_product.index != null) {
        let index = this.form_receipt_product.index;

        if (this.form.receipt_product[index].id) {
          this.form.receipt_product[index].is_edit = true;
        }

        this.form.receipt_product[index].product_name =
          this.form_receipt_product.product_name;
        this.form.receipt_product[index].quantity =
          this.form_receipt_product.quantity;
        this.form.receipt_product[index].point =
          this.form_receipt_product.point;
      } else {
        this.form.receipt_product.push(this.form_receipt_product);
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-product-form");
      });
    },
    resetProductModal() {
      this.$v.$reset();
      this.form_receipt_product = {
        is_edit: false,
        index: null,
        product_name: "",
        quantity: "",
        point: 1
      };
    },
    removeReceiptProduct(index) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.form.receipt_product[index].hasOwnProperty("id")) {
            this.form.receipt_product_delete.push(
              this.form.receipt_product[index]
            );
          }

          this.form.receipt_product.splice(index, 1);
        }
      });
    },
    openRewardModal(data = null, index = null) {
      if (data) {
        this.form_receipt_reward.reward_name = data.reward_name;
        this.form_receipt_reward.quantity = data.quantity;
        this.form_receipt_reward.point = data.point;
        if (Array.isArray(data.member_tier_ids)) {
          this.form_receipt_reward.member_tier_ids = [...data.member_tier_ids];
        } else if (data.member_tier_id != null) {
          this.form_receipt_reward.member_tier_ids = [Number(data.member_tier_id)];
        } else {
          this.form_receipt_reward.member_tier_ids = [];
        }
        this.form_receipt_reward.member_tier_id =
          this.form_receipt_reward.member_tier_ids.length > 0
            ? this.form_receipt_reward.member_tier_ids[0]
            : null;
        this.form_receipt_reward.image = data.image;
        this.form_receipt_reward.newImage = data.newImage;
        this.form_receipt_reward.description = data.description;
        this.form_receipt_reward.index = index;
      } else {
        this.form_receipt_reward.index = null;
        this.form_receipt_reward.member_tier_id = null;
        this.form_receipt_reward.member_tier_ids = [];
      }

      this.$bvModal.show("modal-reward-form");
    },
    validateRewardModalState(name) {
      const { $dirty, $error } = this.$v.form_receipt_reward[name];
      return $dirty ? !$error : null;
    },
    async handleSubmitReward(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$v.form_receipt_reward.$touch();

      if (this.$v.form_receipt_reward.$anyError) {
        return;
      }

      await this.handleSaveReward();
    },
    normalizeRewardFromApi(row) {
      let tierIds = [];
      if (Array.isArray(row.member_tier_ids)) {
        tierIds = row.member_tier_ids.map(Number);
      } else if (row.member_tier_id != null) {
        tierIds = [Number(row.member_tier_id)];
      }
      return {
        id: row.id,
        campaign_id: row.campaign_id,
        reward_name: row.reward_name,
        quantity: row.quantity,
        point: row.point,
        member_tier_id: row.member_tier_id != null ? row.member_tier_id : null,
        member_tier_ids: tierIds,
        member_tier: row.member_tier || null,
        image: row.image,
        description: row.description,
        newImage: null
      };
    },
    async persistReceiptRewardViaApi() {
      const idx = this.form_receipt_reward.index;
      const fr = this.form_receipt_reward;
      const tierIds = Array.isArray(fr.member_tier_ids)
        ? fr.member_tier_ids
        : [];
      const payload = {
        reward_name: fr.reward_name,
        quantity: parseInt(fr.quantity, 10),
        point: parseInt(fr.point, 10),
        member_tier_ids: tierIds,
        // ส่งตัวแรกไว้ด้วยเพื่อ backward-compatibility เผื่อ backend เก่ายังใช้ member_tier_id
        member_tier_id: tierIds.length > 0 ? tierIds[0] : null,
        description: fr.description
      };
      if (fr.newImage) {
        payload.newImage = fr.newImage;
      }

      const existingRow = idx != null ? this.form.receipt_reward[idx] : null;
      const isUpdate = existingRow && existingRow.id;

      if (isUpdate) {
        const { data } = await this.$store.dispatch(
          UPDATE_CAMPAIGN_RECEIPT_REWARD,
          {
            campaign_id: this.id,
            reward_id: existingRow.id,
            data: payload
          }
        );
        if (data.status !== "success") {
          throw new Error(this.$t("RESPONSE_MESSAGE." + data.error));
        }
        const normalized = this.normalizeRewardFromApi(data.data);
        // Mock frontend: เก็บรายการ multi-tier ที่เลือกไว้เสมอแม้ backend ยังไม่รองรับ array
        normalized.member_tier_ids = [...tierIds];
        this.$set(this.form.receipt_reward, idx, normalized);
        return;
      }

      if (!payload.newImage) {
        throw new Error(
          this.$t("PAGE.DEFAULT.FORM.VALIDATION.CHECK_DATA_ALL_TAB")
        );
      }

      const { data } = await this.$store.dispatch(
        CREATE_CAMPAIGN_RECEIPT_REWARD,
        {
          campaign_id: this.id,
          data: payload
        }
      );
      if (data.status !== "success") {
        throw new Error(this.$t("RESPONSE_MESSAGE." + data.error));
      }
      const normalized = this.normalizeRewardFromApi(data.data);
      // Mock frontend: เก็บรายการ multi-tier ที่เลือกไว้เสมอแม้ backend ยังไม่รองรับ array
      normalized.member_tier_ids = [...tierIds];
      this.form.receipt_reward.push(normalized);
    },
    async handleSaveReward() {
      if (this.id) {
        Swal.fire({
          title: `${this.$t("LOADING")}`,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 36000,
          onOpen: () => {
            Swal.showLoading();
          }
        });
        try {
          await this.persistReceiptRewardViaApi();
          Swal.close();
          this.$nextTick(() => {
            this.$bvModal.hide("modal-reward-form");
          });
        } catch (err) {
          Swal.close();
          Swal.fire({
            icon: "error",
            text: `${err.message || err}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        }
        return;
      }

      const tierIds = Array.isArray(this.form_receipt_reward.member_tier_ids)
        ? [...this.form_receipt_reward.member_tier_ids]
        : [];

      if (this.form_receipt_reward.index != null) {
        let index = this.form_receipt_reward.index;

        if (this.form.receipt_reward[index].id) {
          this.form.receipt_reward[index].is_edit = true;
        }

        this.form.receipt_reward[index].reward_name =
          this.form_receipt_reward.reward_name;
        this.form.receipt_reward[index].point = this.form_receipt_reward.point;
        this.form.receipt_reward[index].quantity =
          this.form_receipt_reward.quantity;
        this.form.receipt_reward[index].member_tier_ids = tierIds;
        this.form.receipt_reward[index].member_tier_id =
          tierIds.length > 0 ? tierIds[0] : null;
        this.form.receipt_reward[index].image = this.form_receipt_reward.image;
        this.form.receipt_reward[index].newImage =
          this.form_receipt_reward.newImage;
        this.form.receipt_reward[index].description =
          this.form_receipt_reward.description;
      } else {
        this.form.receipt_reward.push({
          ...this.form_receipt_reward,
          member_tier_ids: tierIds,
          member_tier_id: tierIds.length > 0 ? tierIds[0] : null
        });
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-reward-form");
      });
    },
    resetRewardModal() {
      this.$v.$reset();
      this.form_receipt_reward = {
        is_edit: false,
        index: null,
        reward_name: "",
        quantity: "0",
        point: "0",
        member_tier_id: null,
        member_tier_ids: [],
        image: null,
        newImage: null,
        description: null
      };
    },
    getRewardTierLabels(item) {
      if (!item) return [];
      if (
        Array.isArray(item.member_tier_ids) &&
        item.member_tier_ids.length > 0
      ) {
        return item.member_tier_ids
          .map((id) => {
            const tier = this.memberTiers.find(
              (t) => Number(t.id) === Number(id)
            );
            return tier ? tier.name : `Tier ${id}`;
          })
          .filter(Boolean);
      }
      if (item.member_tier_id != null) {
        const tier = this.memberTiers.find(
          (t) => Number(t.id) === Number(item.member_tier_id)
        );
        if (tier) return [tier.name];
        if (item.member_tier && item.member_tier.name) {
          return [item.member_tier.name];
        }
        return [`Tier ${item.member_tier_id}`];
      }
      return [];
    },
    getRewardTierBadges(item) {
      return rewardTierBadges(item && item.member_tier_ids, this.memberTiers);
    },
    getRewardTierLabel(item) {
      const labels = this.getRewardTierLabels(item);
      return labels.length > 0 ? labels.join(", ") : "ทั้งหมด";
    },
    removeReceiptReward(index) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return;
        }
        const row = this.form.receipt_reward[index];
        if (this.id && row.id) {
          Swal.fire({
            title: `${this.$t("LOADING")}`,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 36000,
            onOpen: () => {
              Swal.showLoading();
            }
          });
          try {
            const { data } = await this.$store.dispatch(
              DELETE_CAMPAIGN_RECEIPT_REWARD,
              {
                campaign_id: this.id,
                reward_id: row.id
              }
            );
            Swal.close();
            if (data.status !== "success") {
              Swal.fire({
                icon: "error",
                text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              return;
            }
            this.form.receipt_reward.splice(index, 1);
          } catch (error) {
            Swal.close();
            Swal.fire({
              icon: "error",
              text: `${error}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          return;
        }
        if (row.hasOwnProperty("id")) {
          this.form.receipt_reward_delete.push(row);
        }
        this.form.receipt_reward.splice(index, 1);
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    toBase64SingleFile(event) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onload = (e) => {
            resolve(e.target.result);
          };
          reader.readAsDataURL(event);
        } catch (error) {
          reject(error.toString());
        }
      });
    },
    async onSubmit() {
      this.isSubmit = true;
      this.$v.form.$touch();

      if (this.form.new_landing_image) {
        this.form.new_landing_image_src = await this.toBase64SingleFile(
          this.form.new_landing_image
        );
      }

      if (this.$v.form.$anyError) {
        Swal.fire({
          icon: "error",
          html: this.$t("PAGE.DEFAULT.FORM.VALIDATION.CHECK_DATA_ALL_TAB"),
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
        });
        return;
      }

      const payload = this.prepareCampaignPayload(this.form);
      if (this.id) {
        this.updateData(payload, this.id);
      } else {
        this.createData(payload);
      }
    },
    createData(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();

          const isActivePayload = this.form.company_id
            ? { ...data, company_id: this.form.company_id }
            : data;
          this.$store
            .dispatch(CREATE_CAMPAIGN, { data: isActivePayload })
            .then(({ data }) => {
              Swal.close();
              this.isSubmit = false;
              if (data.status === "success" && data.data.message) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data.message)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                // ไปหน้าแก้ไขของแคมเปญใหม่ — watch $route จะล้างฟอร์มแล้วโหลดแคมเปญนี้ให้เอง
                const _companyId =
                  this.$route.params.companyId || this.$route.query.companyId;
                this.$router.push({
                  path: `/campaign/form/campaign_receipt/${data.data.id}`,
                  query: _companyId ? { companyId: _companyId } : {},
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              this.isSubmit = false;
              Swal.close();
              // เช่น campaign เต็ม plan: backend ตอบ 403 พร้อมข้อความให้ Upgrade
              const message =
                error.response &&
                error.response.data &&
                error.response.data.message;
              Swal.fire({
                icon: "error",
                text: `${message || error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    updateData(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          const updatePayload = this.form.company_id
            ? { ...data, company_id: this.form.company_id }
            : data;
          this.$store
            .dispatch(UPDATE_CAMPAIGN, { id, data: updatePayload })
            .then(({ data }) => {
              this.isSubmit = false;
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getCampaign(this.id);
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              this.isSubmit = false;
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    updateDataIsActive(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          const isActivePayload = this.form.company_id
            ? { ...data, company_id: this.form.company_id }
            : data;
          this.$store
            .dispatch(UPDATE_CAMPAIGN_ISACTIVE, { id, data: isActivePayload })
            .then(({ data }) => {
              this.isSubmit = false;
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getCampaign(this.id);
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch((error) => {
              this.isSubmit = false;
              Swal.close();
              // API ตอบ 403 พร้อมข้อความ (เช่นเปิดเกินโควต้าแพ็กเกจ) ให้แสดงข้อความนั้นแทน "Request failed..."
              const message =
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
                  ? error.response.data.message
                  : `${error}`;
              Swal.fire({
                icon: "error",
                text: message,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
              // สวิตช์ถูกเปลี่ยนไปก่อนยิง API แล้ว โหลดใหม่ให้กลับไปตรงกับค่าจริงใน DB
              this.getCampaign(this.id);
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      const companyId = this.$route.params.companyId || this.$route.query.companyId;
      if (companyId) {
        this.$router.push({ path: `/company-management/${companyId}/campaign` });
      } else {
        this.$router.push({ path: "/campaign" });
      }
    },
    deleteBannerImage(index) {
      if (this.form.images[index].id != null) {
        this.form.images_delete.push(this.form.images[index].id);
      }
      this.form.images.splice(index, 1);
      this.preview.images.splice(index, 1);
    }
  }
};
</script>

<style>
.image-preview {
  width: 100%;
  border: solid 1px #eee;
  border-radius: 5px;
}

.image-object-fit {
  object-fit: cover;
}

.rc-receipt-deselect-all.btn-link {
  color: #dc3545 !important;
}

.rc-receipt-deselect-all.btn-link:hover:not(:disabled) {
  color: #bd2130 !important;
}

.rc-receipt-deselect-all.btn-link:disabled {
  color: #6c757d !important;
}

#receipt-type-input .custom-control-label {
  font-size: 1.2rem !important;
}

#receipt-type-input .custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  padding-left: 2rem;
  padding-bottom: 5px;
}

.bg-dashboard {
  background-color: rgb(141, 0, 0);
}

.col-end {
  display: flex;
  justify-content: flex-end;
}

.campaign-form-tabs-wrap .card-header {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.campaign-form-tabs-wrap .card-header .nav {
  flex-wrap: nowrap;
  white-space: nowrap;
  min-width: min-content;
}

.campaign-form-tabs-wrap .card-header .nav-item {
  flex-shrink: 0;
}

.reward-member-tier-select .vue-treeselect__multi-value-item {
  padding: 0;
  background: transparent;
}

.reward-member-tier-select .vue-treeselect__multi-value-label {
  padding: 0;
}

.reward-member-tier-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.reward-member-tier-select .vue-treeselect__value-remove {
  color: #7e8299;
}
</style>
